//
// AutoInteractionMode.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var AutoInteractionMode = {
    NONE:0,
    ONEWAYFILTER:1,
    TWOWAYFILTER:2,
    BRUSH:3
};
export default AutoInteractionMode;
